import React from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import colors from 'constants/colors';
import { useMutation } from '@apollo/client';
import { DOWNLOAD_RECEIPT } from 'graphql/service';
import { Container } from './styles';
import { debouncedErrorMessage } from 'utils/messageUtil';

const ModalDownloadReceipt = ({
  buttonLabel,
  buttonStyle,
  buttonIcon,
  IconStyle,
  transactionId
}) => {

  const [isOpen, setIsOpen] = React.useState(false);
  const [downloadReceipt, { loading }] = useMutation(DOWNLOAD_RECEIPT,
    {
      onCompleted: (data) => {
        const url = window.URL.createObjectURL(new Blob([data.downloadReceipt], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'receipt.pdf');
        document.body.appendChild(link);
        link.click();
        link.remove();
        setIsOpen(false);
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    },
  );

  const handleDownloadReceipt = () => {
    if(loading) return
    downloadReceipt({
      variables: {
        input: {
          transactionId
        }
      }
    });
  }

  return (
    <MainModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className="modal-success"
      buttonLabel={buttonLabel}
      buttonStyle={buttonStyle}
      buttonIcon={buttonIcon}
      IconStyle={IconStyle}
      additionalstyle={`
        max-width: 500px;
        .modal-content{
          height: 100%;
          .close {
            z-index: 200;
          }   
          .modal-body{
            position: relative;
            height: 100%;
          }
        }
        background: ${colors.black5};
        top: 179px;
      `}
    >
      <Container>
        <div className='text'>{`Are you sure you want to download the receipt of this group?`}</div>
        <Button
          danger
          onClick={() => setIsOpen(false)}
          additionalstyle={`
            width: 79px;
            margin-top: 24px;
            margin-right: 16px;
          `} 
        >
          Cancel
        </Button>
        <Button
          success
          onClick={handleDownloadReceipt}
          data-loading={loading}
          additionalstyle={`
            width: 158px;
            margin-top: 24px;
          `}
        >
          {loading? null: 'Download as PDF'}
        </Button>
      </Container>
    </MainModal>
  );
}

export default ModalDownloadReceipt;
